import { IconCheckCircleWhite } from '../../../../assets/icons'
import carPersonalImage from '../../../../assets/images/goidichvu_loaixeotocanhan.png'
import bikePersonalImage from '../../../../assets/images/goidichvu_loaixemaycanhan.png'
import bikeFamilyImage from '../../../../assets/images/goidichvu_loaixemaygiadinh.png'
import { VEHICLE_TYPE } from '../../../../constants/global'
import { formatTwoDigitValue } from '../../../../helper/common'
import SafeImage from '../../../../components/BasicComponent/SafeImage'
import './index.scss'

const PRODUCT_DISPLAY_CONFIG = {
  CAR_PERSONAL: {
    image: carPersonalImage,
    background: 'linear-gradient(180deg, #28ADEF 20.67%, #FFDAFD 100%)'
  },
  MOTORBIKE_PERSONAL: {
    image: bikePersonalImage,
    background: 'linear-gradient(180deg, #EF5859 0%, #FFFFDA 135.4%)'
  },
  MOTORBIKE_FAMILY: {
    image: bikeFamilyImage,
    background: 'linear-gradient(180deg, #F1A01B 0%, #FFE1BE 135.4%)'
  }
}

function isMotorbikeProduct(vehicleType) {
  return [VEHICLE_TYPE.MOTOBIKE, VEHICLE_TYPE.ELECTRIC_MOTORBIKE].includes(Number(vehicleType))
}

function getProductDisplayConfig(product) {
  if (Number(product?.vehicleType) === VEHICLE_TYPE.CAR) {
    return PRODUCT_DISPLAY_CONFIG.CAR_PERSONAL
  }

  if (isMotorbikeProduct(product?.vehicleType) && Number(product?.productSize) > 1) {
    return PRODUCT_DISPLAY_CONFIG.MOTORBIKE_FAMILY
  }

  return PRODUCT_DISPLAY_CONFIG.MOTORBIKE_PERSONAL
}

function getVehicleQuantityText(product) {
  const vehicleCount = Number(product?.productSize) || 1
  const vehicleLabel = Number(product?.vehicleType) === VEHICLE_TYPE.CAR ? 'ô tô' : 'xe máy'

  return `${formatTwoDigitValue(vehicleCount)} ${vehicleLabel}`
}

export default function PackageVehicleItem({ product, active = false, onClick, isLoading = false }) {
  if (isLoading) {
    return (
      <div className="TrafficFineNotificationServicesVehicleItemWrap" aria-hidden="true">
        <div className="TrafficFineNotificationServicesVehicleItem TrafficFineNotificationServicesVehicleItem_skeleton">
          <div className="TrafficFineNotificationServicesVehicleItem_nameSkeleton" />
          <div className="TrafficFineNotificationServicesVehicleItem_quantitySkeleton" />

          <div className="TrafficFineNotificationServicesVehicleItem_imageWrap">
            <div className="TrafficFineNotificationServicesVehicleItem_imageSkeleton" />
          </div>
        </div>
      </div>
    )
  }

  const productDisplayConfig = getProductDisplayConfig(product)

  return (
    <div className="TrafficFineNotificationServicesVehicleItemWrap">
      {active ? (
        <div className="TrafficFineNotificationServicesVehicleItem_badge">
          <IconCheckCircleWhite className="TrafficFineNotificationServicesVehicleItem_badgeIcon" />
          <span>Đang chọn</span>
        </div>
      ) : null}

      <button
        type="button"
        className={`TrafficFineNotificationServicesVehicleItem ${active ? 'TrafficFineNotificationServicesVehicleItem_active' : ''}`.trim()}
        style={active ? { background: productDisplayConfig.background } : undefined}
        onClick={onClick}
        aria-pressed={active}>
        <div className="TrafficFineNotificationServicesVehicleItem_name">{product?.productName}</div>
        <div className="TrafficFineNotificationServicesVehicleItem_quantity">{getVehicleQuantityText(product)}</div>

        <div className="TrafficFineNotificationServicesVehicleItem_imageWrap">
          <SafeImage src={productDisplayConfig.image} className="TrafficFineNotificationServicesVehicleItem_image" />
        </div>
      </button>
    </div>
  )
}

